<template>
  <div ref="scrollContainer" style="width: 100%;height:100%;overflow-x: hidden" @click="handleClick">

<!--      &lt;!&ndash;    第一层:照片&ndash;&gt;-->
<!--      <div class="div1-MAU">-->
<!--        <img :src="backgroundImg" width="100%" style="height: 100%">-->
<!--      </div>-->

      <!--    第二层-->
      <div class="div2-MAU">
        <a class="div2-a1-MAU">
          <a class="div2-a2-MAU" style="color: #ff4d51"><strong>News Center/ 新闻中心</strong></a>
          <a class="div2-a2-MAU" style="margin-top: 20px">
            <button class="div2-btn-MAU"
                    :style="{backgroundColor:button1_color}"
                    @click="button_first_click">行业新闻
            </button>
            <button class="div2-btn-MAU"
                    style="margin-left: 10%"
                    :style="{backgroundColor:button2_color}"
                    @click="button_second_click">
              常见问题
            </button>
          </a>
        </a>
      </div>
      <!--    第三层-->
      <div class="div3-MAU">
          <router-view></router-view>
      </div>

      <!--    第八层：底框-->
      <div class="div9-MFP">
        <div class="div9-div1-MFP">
          <a class="div9-a1-MFP">联系人：{{this.$store.state.contactIntroduce.personName}}</a><br>
          <a class="div9-a1-MFP">联系方式：{{this.$store.state.contactIntroduce.phoneNumber}}</a><br>
          <a class="div9-a1-MFP">邮箱：{{this.$store.state.contactIntroduce.email}}</a><br>
          <a class="div9-a1-MFP">地址：{{this.$store.state.contactIntroduce.address}}</a><br>
        </div>
        <div class="div9-div2-MFP">
          <a class="div9-a2-MFP" href="https://beian.miit.gov.cn/" target="_blank">{{this.$store.state.contactIntroduce.recordNumber}}</a><br>
          <a class="div9-a2-MFP" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33108202000840" target="_blank">{{this.$store.state.contactIntroduce.policeRecordNumber}}</a><br>
        </div>
        <div class="div9-div2-MFP">
          <a style="font-family: Avenir">Copyright © 2024</a><br>
          <a>版权所有©浙江纵海自动化设备有限公司</a><br>
        </div>
        <div class="div9-div2-MFP">
          <a>声明:本站部分数据来源于互联网,与本公司无关,若有侵权请联系客服删除。</a>
        </div>
      </div>

  </div>
</template>

<script>
  import '../css/mobile/MNC_MobileNewsCenter.css'
  import '../css/mobile/MAU_MobileAboutUs.css'
  import '../css/mobile/MFP_MobileFirstPage.css'

  export default {
    name: "MobileNewsCenter",
    data() {
      return {
        //  背景照片
        backgroundImg: require('../../public/image/浙江纵海4.jpg'),
        //  按钮颜色
        button1_color: 'red',
        button2_color: '#337ab7',
      }
    },
    // mounted(){
    //   this.scrollToTop();
    // },
    methods: {
      //滚动置顶
      scrollToTop(){
        const position=0;
        this.$refs.scrollContainer.scrollTop=position;
      },
      //第一个按钮点击事件
      button_first_click() {
        this.button1_color = 'red';
        this.button2_color = '#337ab7';
        this.$router.push({path: '/MobileNewsCenter'}).catch(() => {
        });
      },
      //第二个按钮点击事件
      button_second_click() {
        this.button1_color = '#337ab7';
        this.button2_color = 'red';
        this.$router.push({path: '/MobileCommonQuestions'}).catch(() => {
        });
      },
      handleClick() {
        let that = this;
        if(that.$store.state.isShowNav==true){
          that.$store.state.isShowNav = false;
        }
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/mobile/MobileNewsCenter.vue